<template>
    <div id="app">
        <app-header v-if="showHeader"></app-header>
        <portal-target name="notice"></portal-target>
        <div class="container">
            <router-view :key="routeKey" />
        </div>
        <portal-target name="modal"></portal-target>
        <app-footer v-if="showFooter"></app-footer>
        <bmr-busy v-if="busy"></bmr-busy>
        <flash-message outer-class="flash-message" transition-name="slide"></flash-message>
    </div>
</template>

<script>
import Header from '@/components/partials/Header';
import Footer from '@/components/partials/Footer';

import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('bmr');

export default {
    name: 'App',
    metaInfo () {
        return {
            title: this.$gettext('The Workshop'),
            titleTemplate: `%s | ${this.$gettext('Groupe BMR merchant portal')}`,
            link: [
                { rel: 'apple-touch-icon', sizes: '180x180', href: `/static/favicons/${this.currentLanguage}/apple-touch-icon.png` },
                { rel: 'icon', type: 'image/png', sizes: '32x32', href: `/static/favicons/${this.currentLanguage}/favicon-32x32.png` },
                { rel: 'icon', type: 'image/png', sizes: '16x16', href: `/static/favicons/${this.currentLanguage}/favicon-16x16.png` },
                { rel: 'manifest', href: `/static/favicons/${this.currentLanguage}/site.webmanifest` },
                { rel: 'mask-icon', href: `/static/favicons/${this.currentLanguage}/safari-pinned-tab.svg', color: '#00783a` },
            ],
            meta: [
                { property: 'msapplication-TileColor', content: '#00783a' },
                { property: 'theme-color', content: '#00783a' },
            ]
        };
    },
    components: {
        'app-header': Header,
        'app-footer': Footer,
    },
    computed: {
        ...mapState(['activeStore', 'busy']),
        showHeader () {
            return typeof this.$route.meta.showHeader === 'undefined' || this.$route.meta.showHeader;
        },
        showFooter () {
            return typeof this.$route.meta.showFooter === 'undefined' || this.$route.meta.showFooter;
        },
        routeKey () {
            let route = this.$route.meta.key || this.$route.fullPath;
            return this.activeStore ? `${route}-store-${this.activeStore.id}` : route;
        }
    },
    watch: {
        busy () {
            if (this.busy == true) {
                document.body.style.setProperty('overflow', 'hidden');
                document.body.style.setProperty('max-height', '100vh');
            } else {
                document.body.style.removeProperty('overflow');
                document.body.style.removeProperty('max-height');
            }
        },
        currentLanguage () {
            if (!this.$route.meta.skipLanguageUpdate && this.$route.name) {
                this.$router.push({ name: this.localizedRoute(this.$route.name), params: this.$route.params });
            }
        }
    }
};
</script>
<style lang="scss">
@import './styles/main.scss';
@import './styles/global.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue